export const FOLDER_COPY = {
  quizCount: (count: string) => `${count}개 퀴즈`,
  createCard: '새 폴더',
  tabQuizzes: '퀴즈',
  tabFolders: '폴더',
  modalTitle: '폴더 만들기',
  nameLabel: '이름',
  namePlaceholder: '예) 초등 1-1 국어',
  hideTitle: '자료실에서 숨기기',
  hideDescription:
    '폴더가 [자료실]에 공유되지 않아요. 담긴 공개 퀴즈는 계속 공개돼요.',
  /** 폴더 비공개 전환 전 확인 (R-28 · Figma 33565:2376). 완료 토스트는 두지 않는다. */
  hideConfirmTitle: '폴더를 자료실에서 숨길까요?',
  hideConfirmDescription: '폴더 안의 공개 퀴즈는 계속 자료실에 공유돼요.',
  emptyPublishBlocked: '퀴즈를 담으면 자료실에 공개할 수 있어요.',
  submit: '만들기',
  createSuccess: '폴더를 만들었어요',
  createError: '폴더를 만들지 못했어요. 잠시 후 다시 시도해 주세요.',

  editPageTitle: '폴더 수정',
  /** 폴더 수정 상단 바의 주 버튼 (Figma 33556:3505). 즉시 저장이라 '나가기' 역할이다. */
  editDone: '수정 완료',
  /**
   * 빈 폴더로 수정 화면을 나갈 때의 확인 (PRD R-40 · ED-05).
   *
   * 이 화면은 자동 저장(R-56)이라 `수정 완료` 는 나가기 버튼이다. 그래서 R-40 의 "저장하면"을
   * **나갈 때**로 읽는다 — 되돌릴 게 없는 대신, 빈 폴더를 만들어 놓고 잊는 것만 한 번 잡아 준다.
   */
  emptySaveConfirmTitle: '퀴즈 없이 저장할까요?',
  emptySaveConfirmDescription:
    '폴더는 비공개로 저장돼 자료실에 보이지 않아요. 퀴즈를 추가하면 공개할 수 있어요.',
  emptySaveCancelAction: '취소',
  emptySaveConfirmAction: '저장',
  sectionBasicInfo: '기본 정보',
  sectionQuizzes: '퀴즈',
  sectionVisibility: '공개 설정',
  /** 퀴즈 추가 모달의 행 조작. */
  itemPreview: '미리보기',
  /** 폴더 수정 화면의 행 조작 (Figma 32600:249101 · 32600:249347). */
  itemMove: '이동',
  itemRemove: '삭제',
  /**
   * 좁은 폭에서 `이동`·`삭제` 를 접어 넣는 케밥 버튼의 접근성 이름 (Figma 33684:147801).
   * 아이콘만 있는 버튼이라 화면에는 안 보이고 보조기기만 읽는다.
   */
  itemMenu: '퀴즈 옵션',
  itemReorder: '순서 변경',
  reorderError: '순서를 바꾸지 못했어요. 잠시 후 다시 시도해 주세요.',
  reorderLoading: '순서를 바꾸려면 퀴즈를 모두 불러올 때까지 기다려 주세요.',
  addQuiz: '퀴즈 추가',

  addQuizModalTitle: '퀴즈 추가',
  itemSelect: '선택',
  addQuizEmpty: '추가할 수 있는 퀴즈가 없어요',
  addItemSuccess: '퀴즈를 추가했어요',
  addItemPublishConfirmTitle: '퀴즈도 함께 공개할까요?',
  addItemPublishConfirmDescription:
    '공개 폴더라 담는 즉시 이 비공개 퀴즈도 공개돼요.',
  addItemPublishConfirmAction: '추가하기',

  /** 내 퀴즈 상세 → 폴더 이동 (Figma 34302:45570 · 34302:42597) */
  moveToFolder: '폴더 이동',
  /** 시안 SV-04·SV-05 기준 문구. */
  saveModalTitle: '폴더 선택',
  saveModalCreate: '폴더 만들기',
  saveModalDefaultLocation: '내 퀴즈',
  /** 퀴즈가 지금 있는 폴더 행의 딱지 (Figma 40317:11216). 그 행은 고를 수 없다. */
  currentLocation: '현재 위치',
  saveModalSubmit: '완료',
  saveModalSubmitting: '저장 중…',
  /** 목록을 받지 못해 모달을 열지 못했을 때. 고를 것이 없는 화면을 띄우지 않는다. */
  saveModalLoadError:
    '폴더 목록을 불러오지 못했어요. 잠시 후 다시 시도해 주세요.',
  saveSuccess: '내 퀴즈에 저장했어요',
  /** 남의 퀴즈를 폴더에 복사했을 때. 이동(`moveSuccess`)과 문장을 가른다 — 원본이 남는지가 다르다. */
  saveToFolderSuccess: (folderName: string) => `‘${folderName}’에 저장했어요.`,
  moveSuccess: (folderName: string) => `‘${folderName}’로 이동했어요.`,
  moveToDefaultSuccess: '‘내 퀴즈’로 이동했어요.',
  viewFolder: '보러 가기',
  /**
   * 저장이 길어질 때만 뜨는 진행 토스트 (PRD R-08). 요청이 600ms 안에 끝나면 나타나지 않는다 —
   * 짧은 요청에 스피너가 깜빡이면 오히려 느려 보인다.
   */
  saveLoading: '퀴즈를 저장하고 있어요.',
  /**
   * 실패 토스트의 재시도 버튼 (PRD R-08).
   *
   * ⚠️ 문구만 두고 버튼은 아직 붙이지 않는다 — 복사 요청이 멱등하지 않아, 응답이 유실된 뒤
   * 다시 부르면 복사본이 둘 생긴다. 서버가 idempotency 를 보장하면 그때 연결한다.
   */
  retry: '다시 시도',
  saveAlreadyInFolder: '이미 이 폴더에 있어요.',
  saveFolderGone: '폴더를 찾을 수 없어요. 다른 위치를 골라 주세요.',
  saveNotAllowed: '이 위치에는 저장할 수 없어요.',
  saveSourceGone: '원본 퀴즈를 더 이상 저장할 수 없어요.',
  saveError: '저장하지 못했어요. 잠시 후 다시 시도해 주세요.',
  addItemError: '퀴즈를 담지 못했어요. 잠시 후 다시 시도해 주세요.',
  renameError: '이름을 변경하지 못했어요.',
  visibilityError: '공개 설정을 변경하지 못했어요.',
  /** 비공개 퀴즈를 공개 폴더로 옮길 때 (Figma 34884:23865). 확인 버튼은 다이얼로그 기본값 `확인`. */
  savePublishConfirmTitle: '퀴즈를 공개할까요?',
  savePublishConfirmDescription:
    '공개 폴더에는 비공개 퀴즈를 넣을 수 없어요. 이 폴더로 이동하면 퀴즈가 공개돼요.',
  emptyItems: '아직 담긴 퀴즈가 없어요',
  /** 폴더 수정의 퀴즈 영구 삭제 확인 (Figma 32600:249319). */
  removeItemConfirmTitle:
    '정말로 퀴즈를 삭제할까요? 삭제된 내용은 복구할 수 없어요.',
  removeItemCancelAction: '취소',
  removeItemConfirmAction: '확인',
  removeItemError: '퀴즈를 삭제하지 못했어요. 잠시 후 다시 시도해 주세요.',
  /** 폴더 삭제 확인 (Figma 33502:52002). 체크박스는 기본 해제 상태다. */
  deleteConfirmTitle: '폴더를 삭제할까요?',
  deleteConfirmDescription: '삭제된 내용은 복구할 수 없어요.',
  deleteWithItemsLabel: '퀴즈도 함께 삭제',
  deleteConfirmAction: '삭제',
  deleteSuccess: '삭제했습니다.',
  deleteError: '폴더를 삭제하지 못했습니다. 잠시 후 다시 시도해 주세요.',
  /*
    자료실에서 숨기기 업셀 모달 (Figma 33340:20787).

    빌드 페이지의 `PRIVATE_QUIZ` 업셀은 주어가 **퀴즈**라 폴더 화면에서 그대로 쓰면 어긋난다.
    아직 번역 시트에 없는 문구라 여기에 하드코딩해 두고, 시트 등록 때 `build:featureUpsell.*`
    키로 한 번에 옮긴다. 이미지·업그레이드 버튼은 기존 설정을 그대로 쓴다.
  */
  upsellModalTitle: '자료실에서 숨기기',
  upsellTitleLead: '자료실에서 숨기기를 통해',
  upsellTitleStrong: '폴더를 공개하지 않고 관리',
  upsellTitleTail: '할 수 있어요.',
  upsellDescription:
    '준비 중이거나 특정 대상에게만 공유할 폴더를 따로 관리 해보세요.',
  upsellNotice: '폴더를 숨기면 자료실 목록에는 공개되지 않습니다.',
  /** 폴더 공개 전환 확인 (Figma 32600:249444). 확인/취소는 다이얼로그 기본 라벨을 쓴다. */
  publishConfirmTitle: '폴더를 공개할까요?',
  publishConfirmDescription: '폴더 안의 비공개 퀴즈가 모두 공개 처리돼요.',
  detailErrorTitle: '폴더를 불러오지 못했어요',
  detailErrorAction: '목록으로 가기',

  detailVisibilityPublic: '공개 폴더',
  detailVisibilityPrivate: '비공개 폴더',
  detailPlayEnter: '첫 퀴즈부터 입장하기',
  detailPlayEnterShort: '입장하기',
  detailPlayPayPlan: '플랜 결제',
  detailManageLabel: '폴더 관리',
  detailPlaySectionLabel: '퀴즈 풀기',
  /**
   * 하단 안내 문구. 서버 `playAction` 5종에 1:1로 맞춘다 — 잠긴 대상이 내 퀴즈인지
   * 남의 퀴즈인지는 서버가 `PLAN_PAYMENT`(내 것만) / `UNAVAILABLE`(그 외)로 접어서 준다.
   */
  /** FD-08: 내 잠긴 퀴즈만 막고 있을 때 — 주어가 나다. */
  detailNoticeLockedMine:
    '현재 플랜에서 사용할 수 없는 프리미엄 기능이 포함된 퀴즈가 있어요. 플랜을 업그레이드하거나 퀴즈를 수정하면 입장할 수 있어요.',
  /** FD-11: 남의 잠긴 퀴즈가 섞였을 때 — 주어가 제작자다. */
  detailNoticeUnavailable:
    '현재 사용할 수 없는 프리미엄 기능이 포함된 퀴즈가 있어요. 퀴즈 제작자가 플랜을 다시 활성화하거나 퀴즈를 수정하면 사용할 수 있어요.',
  detailNoticeLoginRequired: '로그인하면 이 폴더를 이용할 수 있어요.',
  detailManageEdit: '수정',
  /** 빈 폴더 상세 (Figma 34281:41404) */
  detailEmptyTitle: '퀴즈가 없어요',
  detailEmptyDescription: '필요한 퀴즈를 추가해보세요.',
  detailEmptyFindInLibrary: '자료실에서 찾기',
  detailEmptyAddFromMyQuiz: '내 퀴즈에서 추가',

  /**
   * 남의 폴더에서 퀴즈 한 개를 가져오는 행 버튼 (Figma 35044:67158).
   *
   * 기존 `detail.copyToMyQuiz`(내 퀴즈로 복사)와 문구가 다르다 — 시안이 `저장`을 쓰고,
   * 실제로도 위치 선택 모달을 열어 **어디에 저장할지** 고르게 한다.
   */
  detailSaveQuiz: '내 퀴즈로 저장',

  /** 우측 폴더 프로모션 카드 (Figma 35045:76132). */
  promoLabel: '폴더',
  promoDescription: '쌓여 가는 퀴즈, 이제 폴더로 깔끔하게 정리해 보세요',
  promoClose: '닫기',

  /** 폴더 재생이 끝났거나 끊겼을 때 다음 퀴즈 카드 자리에 그대로 그린다. */
  playDoneLabel: '폴더 완주',
  playDoneTitle: '폴더를 모두 풀었어요',
  playRemovedLabel: '폴더 변경됨',
  playRemovedTitle: '폴더가 변경됐어요',

  /** 폴더 전체 페이지 → 내 퀴즈 한 화면 (시안 33442:30166) */
  backToMyQuiz: '뒤로 가기',

  emptyTitle: '만들어진 폴더가 없어요',
  emptyDescription: '첫 번째 폴더를 직접 만들어볼까요?',
  emptyAction: '폴더 만들기',
} as const;
